import React, { createContext, useState, useEffect, useContext } from 'react';
import { collection, onSnapshot, query, orderBy } from 'firebase/firestore';
import { db } from '../firebase';

export const BannersContext = createContext({
  banners: [],
  loading: true,
});

export function useBanners() {
  return useContext(BannersContext);
}

export function BannersProvider({ children }) {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(
      collection(db, 'banners'),
      orderBy('display_order', 'asc')
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const items = snapshot.docs
          .map((doc) => ({
            id: doc.id,
            title: doc.data().title || '',
            subtitle: doc.data().subtitle || '',
            displayOrder: doc.data().display_order ?? 0,
            isVisible: doc.data().is_visible !== undefined ? doc.data().is_visible : true,
            backgroundColor: doc.data().background_color || null,
          }))
          .filter((banner) => banner.isVisible);
        setBanners(items);
        setLoading(false);
      },
      (error) => {
        console.error('Error fetching banners:', error);
        setBanners([]);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  return (
    <BannersContext.Provider value={{ banners, loading }}>
      {children}
    </BannersContext.Provider>
  );
}
